import styled from 'astroturf/react'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const textColor = 'var(--text-color, rgb(26, 26, 26))'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const fontWeightStandard = 'var(--fontWeightStandard, 400)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const colorStrokeDestructive = 'var(--colorStrokeDestructive, var(--coreColorRed600))'
import { useBooleanState } from '@calendly/hooks'
import _Wrapper from "email_verification_input-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=Wrapper";
import _LabelText from "email_verification_input-LabelText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=LabelText";
import _CursorHider from "email_verification_input-CursorHider.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=CursorHider";
import _VirtualCaret from "email_verification_input-VirtualCaret.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=VirtualCaret";
import _DisplayWrapper from "email_verification_input-DisplayWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=DisplayWrapper";
import _Display from "email_verification_input-Display.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=Display";
import _InputBox from "email_verification_input-InputBox.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=InputBox";
import _Input from "email_verification_input-Input.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=Input";
import _FieldBlock from "email_verification_input-FieldBlock.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/email_verification/email_verification_input.js?styleId=FieldBlock";


export const EMAIL_VERIFICATION_CODE_LENGTH = 6
const ALLOWED_KEYS = new Set(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'])

const Wrapper = /*#__PURE__*/styled('label', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

const LabelText = /*#__PURE__*/styled('p', null, {
  displayName: "LabelText",
  styles: _LabelText
})

const CursorHider = /*#__PURE__*/styled('div', null, {
  displayName: "CursorHider",
  styles: _CursorHider
})

const VirtualCaret = /*#__PURE__*/styled('div', null, {
  displayName: "VirtualCaret",
  styles: _VirtualCaret
})

const DisplayWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DisplayWrapper",
  styles: _DisplayWrapper
})

const Display = /*#__PURE__*/styled('div', null, {
  displayName: "Display",
  styles: _Display
})

const InputBox = /*#__PURE__*/styled('div', null, {
  displayName: "InputBox",
  styles: _InputBox
})

const Input = /*#__PURE__*/styled('input', null, {
  displayName: "Input",
  styles: _Input
})

const FieldBlock = /*#__PURE__*/styled('div', null, {
  displayName: "FieldBlock",
  styles: _FieldBlock
})

const CELLS = Array.from({ length: EMAIL_VERIFICATION_CODE_LENGTH }, (_, index) => index)


export const EmailVerificationInput = ({
  error,
  labelText,
  value,
  onChange,
  onFocus
}) => {
  const [virtualCaret, showVirtualCaret, hideVirtualCaret] = useBooleanState(false)
  const digits = value.split('')
  const showCaret = digits.length === EMAIL_VERIFICATION_CODE_LENGTH && virtualCaret

  const cleanInput = (input) => (input || '').replace(/\D/g, '').substring(0, EMAIL_VERIFICATION_CODE_LENGTH)

  const handleKeyPress = (e) => {
    if (!ALLOWED_KEYS.has(e.key)) {
      e.preventDefault()
    }
  }

  const handleOnChange = (e) => {
    const newValue = cleanInput(e.target.value)
    onChange(newValue)
  }

  const handleOnPaste = (e) => {
    e.preventDefault()
    const pasteText = cleanInput(e.clipboardData.getData('Text'))
    onChange(pasteText)
  }

  return (
    <FieldBlock>
      <Wrapper>
        <LabelText>{labelText}</LabelText>
        <InputBox>
          <Input
            type="text"
            name="verification_code"
            value={value}
            maxLength={EMAIL_VERIFICATION_CODE_LENGTH}
            onKeyPress={handleKeyPress}
            onChange={handleOnChange}
            onPaste={handleOnPaste}
            onSelect={(e) => {
              if (e.target.selectionStart === EMAIL_VERIFICATION_CODE_LENGTH && e.target.selectionEnd === EMAIL_VERIFICATION_CODE_LENGTH) {
                showVirtualCaret()
              } else {
                hideVirtualCaret()
              }
            }}
            onFocus={onFocus}
          />
          <DisplayWrapper>
            {
              CELLS.map((index) => (
                <Display
                  key={index}
                  filled={Boolean(digits[index])}
                  isError={!!error}
                >
                  {showCaret && index === EMAIL_VERIFICATION_CODE_LENGTH - 1 && (<VirtualCaret />)}
                </Display>
              ))
            }
            <CursorHider />
          </DisplayWrapper>
        </InputBox>
      </Wrapper>
    </FieldBlock>
  )
}
